import { render, staticRenderFns } from "./powerMains.vue?vue&type=template&id=0b079f76&scoped=true&"
import script from "./powerMains.vue?vue&type=script&lang=js&"
export * from "./powerMains.vue?vue&type=script&lang=js&"
import style0 from "./powerMains.vue?vue&type=style&index=0&id=0b079f76&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b079f76",
  null
  
)

export default component.exports